import React, { useContext, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { GlobalContext } from '../context/GlobalContext';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

const DashboardDetail = () => {

    const { state, handleFunction } = useContext(GlobalContext);

    let { detail, setDetail } = state

    let { setStatusSpan, formatRupiah } = handleFunction

    let { IdData } = useParams();

    useEffect(() => {
        if (IdData !== undefined) {
            axios.get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`).then((res) => {
                setDetail(res.data);
            }).catch((error) => {
                console.log(error);
            })
        }
    }, [])

    return (
        <>
            <div className="mx-4 my-4 py-4 w-screen bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                <div className="flex flex-col items-center pb-10">
                    <img
                        className="mb-3 w-24 h-24 rounded-full shadow-lg"
                        src={detail.company_image_url}
                        alt=""
                    />
                    <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">
                        {detail.company_name}
                    </h5>
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-400">
                        {detail.title}
                    </span>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        {detail.company_city}
                    </span>
                    {setStatusSpan(detail.job_status)}
                    <div className="text-justify mx-8 my-4">
                        <h6 className="mb-2 text-md font-bold tracking-tight text-gray-900 dark:text-white mr-2">
                            Kisaran Gaji:
                        </h6>
                        <h5 className="mb-2 text-md font-normal tracking-tight text-gray-900 dark:text-white">
                            {formatRupiah(detail.salary_min)} s/d {formatRupiah(detail.salary_max)}
                        </h5>
                        <h6 className="mb-2 text-md font-bold tracking-tight text-gray-900 dark:text-white mr-2">
                            Job Type:
                        </h6>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{detail.job_type}</p>
                        <h6 className="mb-2 text-md font-bold tracking-tight text-gray-900 dark:text-white mr-2">
                            Job Tenure:
                        </h6>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{detail.job_tenure}</p>
                        <h6 className="mb-2 text-md font-bold tracking-tight text-gray-900 dark:text-white mr-2">
                            Description:
                        </h6>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{detail.job_description}</p>
                        <h6 className="mb-2 text-md font-bold tracking-tight text-gray-900 dark:text-white mr-2">
                            Qualification:
                        </h6>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{detail.job_qualification}</p>
                    </div>
                    <div className="flex mt-4 space-x-3 md:mt-6">
                        <Link
                            to="/list-job"
                            className="inline-flex items-center py-2 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                            <ArrowLeftIcon className="ml-1 mr-1 w-4 h-4" />
                            Back
                        </Link>
                    </div>
                </div>
            </div>

            {/* <div className="mx-5 my-5 flex flex-col items-center bg-white rounded-lg border shadow-md md:flex-row md:max-w-xl hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700">
                <img className="object-cover w-full h-full rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={data.company_image_url} alt="" />
                <div className="flex flex-col justify-between p-4 leading-normal">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{data.title}</h5>
                    <div className='flex'>
                        <h5 className="mb-2 text-lg font-bold tracking-tight text-blue-600 dark:text-white mr-2">
                            {data.company_name}
                        </h5>

                        {setStatusSpan(data.job_status)}
                    </div>
                    <h6 className="mb-2 text-md font-bold tracking-tight text-gray-900 dark:text-white mr-2">
                        Description:
                    </h6>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{data.job_description}</p>

                    <Link to="/list-job"
                        className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                        <ArrowLeftIcon className="ml-1 mr-1 w-4 h-4" />
                        Back to List
                    </Link>
                </div>
            </div> */}
        </>
    )
}

export default DashboardDetail;